module.exports = __webpack_public_path__ + "static/media/gpo1.1bea8c23.jpeg";